import React from "react";
import { Redirect } from "react-router-dom";

import RegisterView from "components/Auth/Register/RegisterView";
import { useSelector } from "react-redux";
import { AppRouteURI } from "router/RoleBasedAccess";

const RegisterContainer = () => {
  const { loggedIn } = useSelector((state) => state.auth);
  return loggedIn ? <Redirect to={AppRouteURI.HOME} /> : <RegisterView />;
};

export default RegisterContainer;
